import { ButtonHTMLAttributes, ComponentType, SVGProps } from 'react';
import { HoverTooltip } from '../ui/HoverTooltip';

type SupportDeskActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  variant?: 'primary' | 'secondary';
  /** Texto do tooltip; padrão = label. */
  tooltip?: string;
  /** Quando false, exibe só o ícone (painel estreito). */
  showLabel?: boolean;
};

/**
 * Botão da mesa: em painel estreito só o ícone (com tooltip);
 * com espaço suficiente, ícone + rótulo.
 */
export function SupportDeskActionButton({
  label,
  icon: Icon,
  variant = 'secondary',
  tooltip,
  showLabel = true,
  className = '',
  type = 'button',
  ...props
}: SupportDeskActionButtonProps) {
  const tone =
    variant === 'primary'
      ? 'bg-emerald-600 text-white hover:bg-emerald-700'
      : 'border border-secondary-300 bg-secondary-100 text-secondary-700 hover:bg-secondary-200';

  return (
    <HoverTooltip text={tooltip ?? label}>
      <button
        type={type}
        aria-label={label}
        title={tooltip ?? label}
        className={[
          'inline-flex shrink-0 items-center justify-center rounded-xl text-sm font-semibold transition-colors',
          'disabled:cursor-not-allowed disabled:opacity-50',
          showLabel ? 'gap-1.5 px-3 py-1.5' : 'h-9 w-9',
          tone,
          className,
        ].join(' ')}
        {...props}
      >
        <Icon className="h-4 w-4 shrink-0" aria-hidden />
        {showLabel ? <span>{label}</span> : null}
      </button>
    </HoverTooltip>
  );
}
